<template>
  <div class="wj_wrap">
    <div class="wj_container">
      <div class="wj_title">首页公告</div>

      <div class="wj_content">
        <el-input
          type="textarea"
          :rows="15"
          placeholder="请输入公告内容"
          class="wj_txt"
          v-model="content"
        >
        </el-input>

        <div class="wj_btns">
            <el-button type="primary" @click="add()" class="submit_btn">提 交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as mUtils from "utils/mUtils";
import * as agreeApi from "@/api/agree";
import { axios } from "utils/";
export default {
  data() {
    return {
      content: "",
      agreeId: null,
    };
  },
  created() {
    let that = this;
    that.getAgreeInfo();
  },
  methods: {
    getAgreeInfo(){
      let that = this;
      let data = {};
      data.type=1;
      agreeApi.agreementInfo(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
         that.agreeId = res.data.data.agreeId;
         that.content = res.data.data.content;
      });
    },
    add() {
      let that = this;
      let data = {};
      data.agreeId = that.agreeId;
      data.content = that.content;
      data.type = 1;
    //   if (!that.content){
    //     that.$message.error("请输入公告内容");
    //     return;
    //   }

      agreeApi.add(data).then(function (res) {
        if (res.data.code != 0) {
          that.$message.error(res.data.msg || "操作失败");
          return;
        }
        that.$message({
          message: "操作成功",
          type: "success",
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.wj_wrap {
  width: 100%;
  .wj_container {
    margin: 30px 50px;
    padding: 30px;
    border: 1px solid #e1e1e1;
    border-radius: 10px;
    .wj_title {
      font-size: 16px;
      font-weight: bold;
    }
    .wj_content {
      margin-top: 20px;
      .wj_txt {
        width: 800px;
      }
      .wj_btns{
          width:800px;
          margin-top: 20px;
          text-align: center;
      }
    }
  }
}
</style>
<style lang="less">
  .wj_content {
      .el-textarea__inner {
        padding: 10px 15px;
        line-height: 1.8;
      }
    }
</style>


// WEBPACK FOOTER //
// notice.vue?b1c03884